import template from './taskEvent.html';

function taskEvent($translate, $log, _, groupsService, taskTypesService, moment, timezoneService) {
  function link($scope) {
    $scope.priorities = [
      {
        id: 1,
        name: $translate.instant('PRIORITY_LOW')
      },
      {
        id: 2,
        name: $translate.instant('PRIORITY_MEDIUM')
      },
      {
        id: 3,
        name: $translate.instant('PRIORITY_HIGH')
      }
    ];

    const createEventDescription = () => {
      if ($scope.events) {
        const translatedName = $translate.instant('SYSTEM').toUpperCase();
        $scope.events.forEach((e) => {
          const event = e;
          if (event.user.name === 'SYSTEM') {
            event.user.name = translatedName;
          }
        });
      } else if (!$scope.events) {
        return;
      }

      const currEventIndex = _.indexOf($scope.events, $scope.event) - 1;

      if (currEventIndex < 0) return;

      const currentEvent = $scope.events[currEventIndex];

      const getCurrent = propertyName => {
        const date = new Date(currentEvent[propertyName]);
        if (date instanceof Date && !isNaN(date)) {
          return currentEvent[propertyName];
        }
        return null;
      };

      $scope.eventDiff = [];

      const getDisplayDate = dateValue => {
        const dateFormat = timezoneService.userTimeHourFormat === 12 ? 'h:mm a, DD MMM YYYY' : 'H:mm, DD MMM YYYY';
        return moment.tz(dateValue * 1000, timezoneService.userTimezone).format(dateFormat);
      };

      _.forOwn($scope.event, (value, propertyName) => {
        if (value !== currentEvent[propertyName]) {
          $scope.eventDiff[propertyName] = {
            type: propertyName,
            current: currentEvent[propertyName],
            previous: value
          };

          if (propertyName === 'startDate' || propertyName === 'deadline') {
            $scope.eventDiff[propertyName].previousDisplay = getDisplayDate(value);
            $scope.eventDiff[propertyName].currentDisplay = getDisplayDate(
              getCurrent(propertyName)
            );
          }
        }
      });
    };

    $scope.getPriorityName = (priorityId) => {
      if (!priorityId) return null;
      return _.find($scope.priorities, { id: priorityId }).name;
    };

    $scope.getStatusName = (statusId) => {
      if (!statusId) return null;
      return _.find($scope.taskStatuses, { id: statusId }).name;
    };

    $scope.getGroupName = groupId => groupsService.directory[groupId] || groupId;

    taskTypesService.getTaskStatuses()
      .then((data) => {
        $scope.taskStatuses = data;
        createEventDescription();
      });

    groupsService.getGroups()
      .then((response) => {
        $scope.groups = response;
      }, (response) => {
        $log.error('groupsService.getGroups() ', response);
      });
  }

  return {
    template,
    link,
    restrict: 'E',
    scope: {
      event: '=',
      events: '=',
      truncateNoteTo: '='
    }
  };
}

const taskEventArray = [
  '$translate',
  '$log',
  '_',
  'groupsService',
  'taskTypesService',
  'moment',
  'timezoneService',
  taskEvent
];

export default function (ngModule) {
  ngModule.directive('taskEvent', taskEventArray);
}
